interface OnboardingDestinationProps {
  localStorageAllowed: boolean;
  redirectUrl: string;
  surveyUrl?: string;
}

export interface OnboardingDestination {
  requiresSignIn: boolean;
  url: string;
}

export function resolveOnboardingDestination({
  localStorageAllowed,
  redirectUrl,
  surveyUrl,
}: OnboardingDestinationProps): OnboardingDestination {
  if (localStorageAllowed && surveyUrl) {
    return { requiresSignIn: false, url: surveyUrl };
  }

  return { requiresSignIn: true, url: redirectUrl };
}
